/* istanbul ignore file */
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import { BASE_AMOUNT_TYPES } from '../finance/constants';

const BaseAmountTypeDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => (
  <EnumDropdown options={BASE_AMOUNT_TYPES} placeholder="Select amount type" {...props} />
);

export default BaseAmountTypeDropdown;
